import { gql } from '@apollo/client';

export const GET_MANUAL_URL_CSV = gql`
  query getManualUrlCSV($input: CheckSettingsInput) {
    getManualUrlCSV(input: $input) {
      csv
    }
  }
`;
